/**
 * Hook de correlações: para uma lista de recursos (telefones/endereços/…), busca no grafo quem
 * os compartilha — a contagem e os donos que alimentam o selo `BadgeCorrelacao`.
 *
 * Uma chamada em lote por lista, refeita quando o conjunto de ids muda. É read-only e best-effort:
 * se o grafo falhar, devolve `{}` e a UI segue sem selo.
 */
import { useEffect, useState } from 'react';
import { buscarCorrelacoes, type CorrelacaoCad, type TipoRecurso } from '@/lib/api';

export function useCorrelacoes(
  tipo: TipoRecurso,
  ids: string[],
): Record<string, CorrelacaoCad> {
  const [mapa, setMapa] = useState<Record<string, CorrelacaoCad>>({});
  const chave = ids.join(',');
  useEffect(() => {
    if (ids.length === 0) {
      setMapa({});
      return;
    }
    let vivo = true;
    void buscarCorrelacoes(tipo, ids).then((m) => {
      if (vivo) setMapa(m);
    });
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo, chave]);
  return mapa;
}
